"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
require("./Form.css");
var Label = function (_a) {
    var children = _a.children, className = _a.className, required = _a.required, vertical = _a.vertical, fontWeight = _a.fontWeight, restProps = __rest(_a, ["children", "className", "required", "vertical", "fontWeight"]);
    return (react_1["default"].createElement("label", __assign({}, restProps, { className: "form-label control-label form-label-".concat(vertical ? 'vertical' : 'horizontal', " ").concat(fontWeight ? "vs-label-font-".concat(fontWeight) : '', " ").concat(className || '') }),
        children,
        required && react_1["default"].createElement("span", { className: "form-group-required-sign" }, "*")));
};
exports["default"] = Label;
